/** Google Meet provider — live class via validated external link (https). */
import { makeExternalProvider } from "./external";

export const meetProvider = makeExternalProvider({
  id: "meet",
  name: "Google Meet",
  description: "Clase en vivo por enlace externo de Google Meet (https validado).",
  requiresCredentials: false,
  urlPlaceholder: "https://meet.google.com/…",
});
